<template>

<com-content :loading="is.loading" :empty="!prices.length" :text="text" class="prices">

    <template v-for="price in prices">

        <div class="prices-item-section" :key="price.id" v-if="price.type === $constants.price.section">{{ price.name }}</div>

        <div class="prices-item-price" :key="price.id" v-if="price.type === $constants.price.cost">

            <div class="prices-item-price-text">
                <div class="prices-item-price-text-name">{{ price.name }}</div>
                <div class="prices-item-price-text-description" v-if="price.text">{{ price.text }}</div>
            </div>

            <div class="prices-item-price-cost">{{ price.cost }}</div>

        </div>

    </template>

</com-content>

</template>

<script>

import comContent from './common/Content'

export default {

    components: {
        'com-content': comContent
    },

    data: function() {

        return {
            is: {
                loading: false
            },
            prices: []
        }

    },

    computed: {

        text: function() {

            return {
                empty: this.page.prices_empty
            }

        }

    },

    created: function() {

        this.fetch()

    },

    methods: {

        fetch: function() {

            this.is.loading = true

            this.$api.request('business/prices', {
                slug: this.page.business.slug
            }).then(function(json) {

                this.prices = json.prices

                this.is.loading = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.prices-item-section {
    font-family: "grueber",serif;
    font-size: 20px;
    line-height: 20px;
    color: var(--color-grey-dark);
    text-align: center;
    margin-bottom: 20px;
    margin-top: 40px;
}

.is-mobile .prices-item-section {
    margin-top: 20px;
    font-size: 16px;
    line-height: 16px;
}

.prices-item-section:first-child {
    margin-top: 0px;
}

.prices-item-price {
    display: flex;
    flex-direction: row;
    margin-bottom: 4px;
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    padding: 10px 20px;
    align-items: center;
}

.is-mobile .prices-item-price {
    padding: 10px;
}

.is-desktop .prices-item-price:hover {
    border-color: var(--color-grey-highlight);
}

.prices-item-price-text {
    flex-grow: 1;
    flex-basis: 0;
}

.prices-item-price-text-name {
    font-size: 18px;
    font-family: "grueber",serif;
}

.is-mobile .prices-item-price-text-name {
    font-size: 14px;
}

.prices-item-price-text-description {
    font-weight: 300;
    font-size: 12px;
    margin-top: 4px;
}

.prices-item-price-cost {
    flex-shrink: 0;
    width: 120px;
    font-size: 18px;
    text-align: right;
    font-weight: 700;
}

.is-mobile .prices-item-price-cost {
    font-size: 14px;
}

</style>